import { useNavigate } from 'react-router-dom'
import { IconSchool, IconPlayerPlay } from '@tabler/icons-react'
import { Button } from '@/components/Button.tsx'
import PortalStandardComponent from '@/components/portal/PortalStandardComponent.tsx'
import { useTutorial } from '@/contexts/tutorialContext.tsx'

interface TutorialEntry {
  id: string
  title: string
  description: string
  seriesId: string
  startPath: string
}

const tutorials: TutorialEntry[] = [
  {
    id: 'getting-started',
    title: 'Projekt erstellen',
    description: 'Erstelle dein erstes Projekt, lade Beispiel-Bilder und wähle ein Design aus.',
    seriesId: 'getting-started',
    startPath: '/portal/dashboard',
  },
]

export default function TutorialsPage() {
  const navigate = useNavigate()
  const startTutorial = useTutorial(s => s.startTutorial)
  const isTutorialCompleted = useTutorial(s => s.isTutorialCompleted)

  function handleStart(tutorial: TutorialEntry) {
    navigate(tutorial.startPath)
    setTimeout(() => startTutorial(tutorial.seriesId), 0)
  }

  return (
    <PortalStandardComponent title="Tutorials" noCard>
      <div className="flex flex-col gap-3">
        {tutorials.map(tutorial => {
          const completed = isTutorialCompleted(tutorial.seriesId)
          return (
            <div key={tutorial.id} className="bg-neutral p-5 flex items-center gap-4">
              <div className="bg-primary bg-opacity-10 text-primary rounded-full p-3 flex-shrink-0">
                <IconSchool size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold">{tutorial.title}</span>
                  {completed && (
                    <span className="text-xs opacity-50">Abgeschlossen</span>
                  )}
                </div>
                <p className="text-sm opacity-60 mt-0.5">{tutorial.description}</p>
              </div>
              <Button size="sm" color="primary" onClick={() => handleStart(tutorial)} className="flex-shrink-0">
                <IconPlayerPlay size={16} />
                {completed ? 'Nochmal' : 'Starten'}
              </Button>
            </div>
          )
        })}
      </div>
    </PortalStandardComponent>
  )
}
